import React, { Component } from 'react';
import * as realGamesService from "../services/realGamesService"
import { deckHerosAdminUrl } from '../configs/const';

import Header from './header'
import UserMenu from './userMenu'

export default class RealGamesUnsettledBets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            iframeurl: "",
            isMaintanance: false
        };
    }
    componentDidMount() {
        // realGamesService.getToken().then((res) => {
        //     if (res.status === 200) {
        //         let id = res.data.id
        //         // let deckHerosApi = "http://localhost:3000"
        //         let url = deckHerosAdminUrl + "/user/unsettledbets/" + id
        //         // let url = "http://localhost:3000/user/unsettledbets/" + id
        //         this.setState({ url: url })
        //     }
        // })
        realGamesService.realGamesLaunchReport('unsettledbets').then((res) => {
            if (!!res && !!res.url) {
                // let id = res.data.id
                // let deckHerosApi = "http://localhost:3000"
                let iframeurl = res.url;//data.url;//deckHerosAdminUrl + "/user/accountstatement/" + id
                // let url = "http://localhost:3000/user/accountstatement/" + id
                this.setState({ iframeurl: iframeurl })
            }
        })
    }

    updateMaintanence(status) {
        this.setState({ isMaintanance: status })
    }

    render() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        return (
            <body>
                <Header notify={this.props.notify} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateMaintanence={(status) => { this.updateMaintanence(status) }} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <UserMenu history={this.props.history} isMaintanance={this.state.isMaintanance} />
                    <div className="col-center1 markets">
                        {this.state.url !== "" && < div >
                            <iframe title={"iframe"} key={"iframe"} style={{ height: "84vh", width: "100%", border: "0px" }} src={this.state.iframeurl}></iframe>
                        </div>}
                    </div>
                </div>
            </body>
        )
    }
}
